import { useMemo } from "react";
import { ICustomTheme } from "../../../../../context/theme-context";
import { CustomTheme } from "../../../../../types/custom-theme";
import { RowTool, TitleTools } from "../../styles";
import { ColorSelector } from "../selectors/color-selector";
import { GenericSelect } from "../selectors/generic-select";
import {
  borderRadiusOptions,
  borderRadiusPXOptions,
  generalFontSize,
  generalFontWeight,
  thicknessOptions,
} from "../selectors/utils";
import { useTranslation } from "react-i18next";

export const FieldsGeneralSettingsContainer = ({
  customTheme,
  handleChangeColor,
  handleSelect,
}: ICustomTheme) => {
  const container = useMemo(
    () => customTheme.payment_form.container,
    [customTheme]
  );
  const { t } = useTranslation();

  return (
    <>
      <TitleTools>{t("styles.fields.title")}</TitleTools>

      {/* <ColorSelector
        label="Outside color"
        color={container.outside_color}
        onChange={handleChangeColor.bind(
          null,
          "payment_form.container.outside_color"
        )}
      /> */}

      {/* <ColorSelector
        label="Fill color"
        color={container.fill_color}
        onChange={handleChangeColor.bind(
          null,
          "payment_form.container.fill_color"
        )}
      /> */}

      <ColorSelector
        color={container.edge_color}
        i18n={"styles.fields.borderColor"}
        onChange={handleChangeColor.bind(
          null,
          "payment_form.container.edge_color"
        )}
      />

      <RowTool>
        <GenericSelect
          value={container.edge_weight}
          onChange={handleSelect.bind(
            null,
            "payment_form.container.edge_weight"
          )}
          options={thicknessOptions}
          i18n={"styles.fields.border"}
        />
        <GenericSelect
          value={container.edge_radius}
          onChange={handleSelect.bind(
            null,
            "payment_form.container.edge_radius"
          )}
          options={borderRadiusPXOptions}
          i18n={"styles.fields.borderRadius"}
        />
      </RowTool>
    </>
  );
};
